import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import { AuthContextProvider } from "./context/AuthContext";
import TermsAndConditions from "./pages/terms_and_conditions";
import Login from "./pages/login";
import Register from "./pages/register";
import Home from "./pages/home";
import ProtectedRoute from "./context/ProtectedRoute";
import Dashboard from "./pages/dashboard";
import Settings from "./pages/settings";
import ResetPassword from "./pages/reset_password";
import ErrorPage from "./pages/404";

function App() {
  return (
    <div style={{ fontFamily: 'Avenir' }}>
        <AuthContextProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/" element={<LandingPage />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              
              <Route
              path='/home'
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
  

           <Route
            path='/dashboard/:project_unique_id'
            element={
              <ProtectedRoute>
                <Dashboard/>
              </ProtectedRoute>
            }
          />

          <Route
            path='/settings'
            element={
              <ProtectedRoute>
                <Settings/>
              </ProtectedRoute>
            }
          />  
          
          <Route path="*" element={<ErrorPage/>} />
            </Routes>
          </BrowserRouter>
      </AuthContextProvider>
    </div>
  );
}

export default App;
